/**
 * @generated SignedSource<<28c5a6b0e500ea4459e1f45473c4715a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type DevOpsPullRequestStatus = "DECLINED" | "DRAFT" | "MERGED" | "OPEN" | "UNKNOWN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type main_softwareCodePage_PullRequestsList$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly devOpsEntityRelationships: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly to: {
              readonly data: {
                readonly author?: {
                  readonly __typename: string;
                } | null | undefined;
                readonly authorId?: string | null | undefined;
                readonly repositoryName?: string | null | undefined;
                readonly reviewers?: ReadonlyArray<{
                  readonly user: {
                    readonly __typename: string;
                  } | null | undefined;
                  readonly userId: string | null | undefined;
                } | null | undefined> | null | undefined;
                readonly status?: DevOpsPullRequestStatus | null | undefined;
                readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_FilteredTable" | "main_softwareCodePage_FiltersUI">;
              } | null | undefined;
            };
          };
        } | null | undefined>;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
      };
    };
  };
  readonly " $fragmentType": "main_softwareCodePage_PullRequestsList";
};
export type main_softwareCodePage_PullRequestsList$key = {
  readonly " $data"?: main_softwareCodePage_PullRequestsList$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_PullRequestsList">;
};

import mainSoftwareCodePagePullRequestsListRefetch_graphql from './mainSoftwareCodePagePullRequestsListRefetch.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": {
        "lastUpdatedSortDirection": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "updatedFrom"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": mainSoftwareCodePagePullRequestsListRefetch_graphql
    }
  },
  "name": "main_softwareCodePage_PullRequestsList",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                },
                {
                  "kind": "Variable",
                  "name": "key",
                  "variableName": "projectKey"
                }
              ],
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jiraProjectByKey",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "updatedFrom",
                            "variableName": "updatedFrom"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "filter"
                      },
                      {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                      },
                      {
                        "kind": "Variable",
                        "name": "sort",
                        "variableName": "sort"
                      },
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "project-associated-pr"
                      }
                    ],
                    "concreteType": "AriGraphRelationshipConnection",
                    "kind": "LinkedField",
                    "name": "devOpsEntityRelationships",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "AriGraphRelationshipEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": {
                                "concreteType": "AriGraphRelationship",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "RequiredField",
                                    "field": {
                                      "concreteType": "AriGraphRelationshipNode",
                                      "kind": "LinkedField",
                                      "name": "to",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "name": "data",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "kind": "InlineFragment",
                                              "selections": [
                                                {
                                                  "kind": "ScalarField",
                                                  "name": "status"
                                                },
                                                {
                                                  "kind": "ScalarField",
                                                  "name": "repositoryName"
                                                },
                                                {
                                                  "kind": "FragmentSpread",
                                                  "name": "main_softwareCodePage_FiltersUI"
                                                },
                                                {
                                                  "kind": "FragmentSpread",
                                                  "name": "main_softwareCodePage_FilteredTable"
                                                },
                                                {
                                                  "kind": "ScalarField",
                                                  "name": "authorId"
                                                },
                                                {
                                                  "kind": "LinkedField",
                                                  "name": "author",
                                                  "plural": false,
                                                  "selections": (v0/*: any*/)
                                                },
                                                {
                                                  "concreteType": "DevOpsReviewer",
                                                  "kind": "LinkedField",
                                                  "name": "reviewers",
                                                  "plural": true,
                                                  "selections": [
                                                    {
                                                      "kind": "ScalarField",
                                                      "name": "userId"
                                                    },
                                                    {
                                                      "kind": "LinkedField",
                                                      "name": "user",
                                                      "plural": false,
                                                      "selections": (v0/*: any*/)
                                                    }
                                                  ]
                                                }
                                              ],
                                              "type": "DevOpsPullRequestDetails"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraProjectByKey.devOpsEntityRelationships.edges.node.to"
                                  }
                                ]
                              },
                              "action": "THROW",
                              "path": "jira.jiraProjectByKey.devOpsEntityRelationships.edges.node"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.jiraProjectByKey.devOpsEntityRelationships.edges"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "PageInfo",
                          "kind": "LinkedField",
                          "name": "pageInfo",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                              },
                              "action": "THROW",
                              "path": "jira.jiraProjectByKey.devOpsEntityRelationships.pageInfo.hasNextPage"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.jiraProjectByKey.devOpsEntityRelationships.pageInfo"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.jiraProjectByKey.devOpsEntityRelationships"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.jiraProjectByKey"
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "54ad227e3409b5d5a913af71c2eddfc7";

export default node;
